import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';
import {setNotificationAction as setNotification} from '@pluto/notification/Redux/NotificationActions';
import {editContentPartner, getContentPartnerForEditing} from '@pluto/rest';

export const CONTENT_PARTNER_GET_INITIAL_VALUES_FOR_EDITING =
    'CONTENT_PARTNER_GET_INITIAL_VALUES_FOR_EDITING';
export const CONTENT_PARTNER_RESET_INITIAL_VALUES_FOR_EDITING =
    'CONTENT_PARTNER_RESET_INITIAL_VALUES_FOR_EDITING';

export const setContentPartnerInitialValuesAction = createAction(
    CONTENT_PARTNER_GET_INITIAL_VALUES_FOR_EDITING,
    async (id: number) => {
        return await getContentPartnerForEditing(id);
    }
);

export const resetContentPartnerInitialValuesAction = createAction(
    CONTENT_PARTNER_RESET_INITIAL_VALUES_FOR_EDITING
);

export const editContentPartnerAction = curry(async (params, dispatch) => {
    const {redirect, ...requestParams} = params;
    const [error] = await tryToCatch(editContentPartner, requestParams);

    redirect();

    if (!error)
        return dispatch(
            setNotification({
                type: 'success',
                text: 'Partner information successfully saved',
            })
        );

    const {data: errorData} = error.response;

    return dispatch(
        setNotification({
            type: 'error',
            text: errorData.message,
        })
    );
});
